import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';



export const MasterMerchantFormValidations = {
    id: [{ type: 'required', message: 'This field is required' }],
    code: [{ type: 'required', message: 'This field is required' }],
    name: [{ type: 'required', message: 'This field is required' }],
    user: [{ type: 'required', message: 'This field is required' }],
    password: [
        { type: 'required', message: 'This field is required' },
        { type: 'minlength', value: 6, message: 'Minimal 6 characters' }
    ],
    secret_code: [{ type: 'required', message: 'This field is required' }],
    callback_url: [{ type: 'required', message: 'This field is required' }],
    expired_date: [{ type: 'required', message: 'This field is required' }],
    payment_type: [{ type: 'required', message: 'This field is required' }],
    balance: [
        { type: 'required', message: 'This field is required' },
        { type: 'min', value: 0, message: 'Balance must be at least 0' }
    ],
    bank_account: [{ type: 'required', message: 'This field is required' }],
    bank_name: [{ type: 'required', message: 'This field is required' }],
    bank_branch: [{ type: 'required', message: 'This field is required' }],
    add_params1: [{ type: 'required', message: 'This field is required' }],
    add_params2: [{ type: 'required', message: 'This field is required' }]
};


export const passwordMatchValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const password = group.get('password')?.value;
  const confirmPassword = group.get('cPassword')?.value;

  return password && confirmPassword && password !== confirmPassword
    ? { passwordMismatch: true }
    : null;
};
